import script from "./SanctionResponseItem.vue?vue&type=script&setup=true&lang=js"
export * from "./SanctionResponseItem.vue?vue&type=script&setup=true&lang=js"

import "./SanctionResponseItem.vue?vue&type=style&index=0&id=297c2bee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-297c2bee"]])

export default __exports__